<template>
  <div
    class="row"
    style="
      background: url('/img/bg-1.png') no-repeat left;
      background-size: contain;
      height: 100vh;
      overflow: auto;
    "
  >
    <div v-if="isLoading" class="loading-overlay">
      <loading
        loader="dots"
        :height="170"
        :width="170"
        color="#3282b8"
        background-color="#505273"
        transition="fade"
        :active="isLoading"
        :is-full-page="true"
      ></loading>
    </div>
    <div class="col-lg-12">
      <modal :show.sync="modals.successModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #16cf79;
          "
        >
          <div class="col-lg"></div>
          <div class="col-lg-5">
            <div
              style="
                padding: 15px;
                background-color: transparent;
                border-radius: 100px;
                border: 10px solid white;
              "
            >
              <i
                style="color: white; font-size: 90px; font-weight: 900"
                class="tim-icons icon-check-2"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Successful
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            "
          >
            Congratulations!
          </p>

          <p style="color: #a8a8a8">
            Your account has been successfully created
          </p>

          <div style="display: flex">
            <p style="color: #a8a8a8">Please allow</p>
            &nbsp;
            <p style="font-weight: 600; color: #707070">3 working days</p>
            &nbsp;
            <p style="color: #a8a8a8">for your registration approval</p>
          </div>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Continue' to proceed to login page
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="primary" v-on:click="getLogin()"
              >Continue</base-button
            >
          </div>
        </div>
      </modal>
      <modal :show.sync="modals.failedModal">
        <div
          class="modal-header"
          style="
            margin: -25px -24px 0px -24px;
            padding: 20px 40px 20px 40px;
            background-color: #ea2127;
            text-align: center;
          "
        >
          <div class="col-lg-12">
            <div>
              <i
                style="color: white; font-size: 120px; font-weight: 900"
                class="tim-icons icon-alert-circle-exc"
              ></i>
            </div>
            <div>
              <p
                style="
                  color: white;
                  font-size: 17px;
                  text-align: center;
                  font-weight: 500;
                "
              >
                Failed
              </p>
            </div>
          </div>
          <div class="col-lg"></div>
        </div>
        <div class="col-lg-12 text-center">
          <p
            style="
              margin-top: 50px;
              font-size: 40px;
              font-weight: 500;
              color: #606060;
            "
          >
            Warning!
          </p>

          <p style="color: #a8a8a8">Please fill in all the details.</p>

          <p style="color: #a8a8a8; margin-top: 20px">
            Click 'Retry' to go back.
          </p>
          <div class="col-lg-12 text-center" style="margin-bottom: 50px">
            <base-button type="danger" v-on:click="getLogin()">Exit</base-button
            >&nbsp;
            <base-button type="primary" v-on:click="closeFailedModal()"
              >Retry</base-button
            >
          </div>
        </div>
      </modal>
      <div class="full-page">
        <div class="content">
          <div class="row">
            <div style="margin-top: -70px" class="col-lg-12 text-center">
              <p style="font-size: 29px; color: #358CCB">Sign Up</p>
            </div>
          </div>
          <div class="row">
            <div
              style="margin-top: -30px; margin-bottom: 50px"
              class="col-lg-12 text-center"
            >
              <p style="font-size: 18px; color: #b9b9b9">
                Please fill up the information to register
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-3 d-flex">
              <card
                class="card-eprf"
              >
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  TRANSPORTER DETAILS
                </p>
                <p style="color: #A5A5A5; opacity: 0.7">
                  Transporter Name 
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="transportername"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  DOE No. 
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="doe_no"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Company Address 
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="company_address"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Phone No. 
                </p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="phone_no"
                    :class="{ 'custom-input': true }"
                  />
                  <p v-if="isphone_no" style="font-size: 12px; color: #EC1B23">
                    The length of the phone number is insufficient.
                  </p>
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">Fax No.</p>
                <div style="padding-right: 30px">
                  <input
                    type="text"
                    v-model="fax_no"
                    :class="{ 'custom-input': true }"
                  />
                </div>

                <p style="color: #A5A5A5; opacity: 0.7">
                  Supporting Document (i.e SSM, Form 29, etc)
                </p>
                <div class="fileinput">
                  <label
                    for="file-upload"
                    style="color: white"
                    type="primary"
                    class="btn"
                  >
                    Upload
                  </label>
                  <div
                    class="d-flex justify-content-center spinner"
                    v-if="this.uploadload == true"
                  >
                    <circle-8></circle-8>
                  </div>

                  <input
                    accept="application/pdf"
                    id="file-upload"
                    type="file"
                    ref="file"
                    name="..."
                    class="valid"
                    :multiple="true"
                    aria-invalid="false"
                    style="display: none"
                    v-on:change="onFileChange"
                  />
                </div>
                <div
                  v-if="this.uploadload == false"
                  style="
                    height: 50px;
                    padding: 0px 20px 20px 0px;
                    margin: 0px 30px 20px 0px;
                  "
                  class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                >
                  <div
                    v-for="(file, index) in allfilename"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style="padding-left: 15px; color: #A5A5A5; opacity: 0.7"
                        v-if="selectedFileName"
                        id="file-name"
                      >
                        {{ allfilename[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                        v-if="selectedFileName"
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeFile(index)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                  <div
                    v-for="(file, index) in support_doc_list"
                    :key="index"
                    class="row"
                  >
                    <div class="col-lg-8">
                      <p
                        style="padding-left: 15px; color: #A5A5A5; opacity: 0.7"
                      >
                        {{ support_doc_list[index] }}
                      </p>
                    </div>
                    <div class="col-lg-4">
                      <base-button
                        class="btn-sm btn-cancel"
                        style="font-size: 12px"
                        @click="removeFile2(index)"
                      >
                        Remove
                      </base-button>
                    </div>
                  </div>
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card
                class="card-eprf"
              >
                <p
                  style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px;
                  "
                >
                  VEHICLE DETAILS
                </p>
                <div style="padding-right: 30px">
                  <div
                    style="padding-right: 20px"
                    class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                  >
                    <b-card
                      v-for="(card, index) in vehicles"
                      :key="index"
                      class="card"
                      style="background-color: #f5f6fa; box-shadow: none"
                      border-variant="primary"
                      :header="getVehicleTitle(index)"
                      header-bg-variant="primary"
                      header-text-variant="white"
                    >
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-lg-11"></div>
                          <div
                            v-if="index > 0"
                            style="
                              position: relative;
                              height: 18px;
                              width: 18px;
                              background-color: #ea2127;
                              border-radius: 100px;
                            "
                          >
                            <i
                              style="
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                color: white;
                                font-weight: 900;
                                font-size: 12px;
                              "
                              class="tim-icons icon-simple-remove"
                              @click="handleVehicle(card.id, index)"
                            ></i>
                          </div>
                          <div
                            v-else
                            style="
                              position: relative;
                              height: 18px;
                              width: 18px;
                              background-color: transparent;
                              border-radius: 100px;
                            "
                          ></div>
                        </div>
                      </div>
                      <p style="color: #A5A5A5; opacity: 0.7">
                        Vehicle Registration No.
                        
                      </p>

                      <input
                        type="text"
                        v-model="card.platenumber"
                        :class="{ 'custom-input': true }"
                      />
                      <p
                        style="
                          color: #A5A5A5;
                          font-size: 10px;
                          margin-top: -1px;
                        "
                      >
                        {{ card.errormsg }}
                      </p>
                    </b-card>
                  </div>
                  <p
                    style="cursor: pointer; padding-left: 30px; color: #358CCB"
                    @click="addVehicle()"
                  >
                    + Add Vehicle
                  </p>
                </div>
              </card>
            </div>
            <div class="col-lg-3 d-flex">
              <card
               class="card-eprf"
              >
                <p
                  style="
                    color: #358CCB;
                    font-size: 24px;
                    font-weight: 300;
                    padding: 30px;
                  "
                >
                  DRIVER DETAILS
                </p>

                <div style="padding-right: 30px">
                  <div
                    style="padding-right: 20px"
                    class="scrollable green flex-grow-1 flex-shrink-0 overflow-auto"
                  >
                    <b-card
                      v-for="(card, index) in drivers"
                      :key="index"
                      class="card"
                      style="background-color: #f5f6fa; box-shadow: none"
                      border-variant="primary"
                      :header="getDriverTitle(index)"
                      header-bg-variant="primary"
                      header-text-variant="white"
                    >
                      <div class="col-lg-12">
                        <div class="row">
                          <div class="col-lg-11"></div>
                          <div
                            v-if="index > 0"
                            style="
                              position: relative;
                              height: 18px;
                              width: 18px;
                              background-color: #ea2127;
                              border-radius: 100px;
                            "
                          >
                            <i
                              style="
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                color: white;
                                font-weight: 900;
                                font-size: 12px;
                              "
                              class="tim-icons icon-simple-remove"
                              @click="handleDriver(card.id, index)"
                            ></i>
                          </div>
                          <div
                            v-else
                            style="
                              position: relative;
                              height: 18px;
                              width: 18px;
                              background-color: transparent;
                              border-radius: 100px;
                            "
                          ></div>
                        </div>
                      </div>
                      <p style="color: #A5A5A5; opacity: 0.7">
                        Driver name 
                      </p>
                      <input
                        type="text"
                        v-model="drivername[index]"
                        :class="{ 'custom-input': true }"
                      />
                      <p style="color: #A5A5A5; opacity: 0.7">
                        NRIC / Passport No. 
                      </p>
                      <input
                        type="text"
                        v-model="card.icdriver"
                        :class="{ 'custom-input': true }"
                      />
                      <p
                        style="
                          color: #A5A5A5;
                          font-size: 10px;
                          margin-top: -1px;
                        "
                      >
                        <!-- {{ ic }} -->
                        {{ card.error1msg }}
                      </p>
                    </b-card>
                  </div>
                  <p
                    style="cursor: pointer; padding-left: 30px; color: #358CCB"
                    @click="addDriver()"
                  >
                    + Add Driver
                  </p>
                </div>
              </card>
            </div>
            <div class="col-lg"></div>
          </div>
          <div class="row">
            <div class="col-lg"></div>
            <div class="col-lg-6"></div>
            <div class="col-lg-3 text-right">
              <base-button type="danger" v-on:click="cancelRegister()"
                >Back</base-button
              >&nbsp;
              <base-button type="primary" v-on:click="handleDone()"
                >Done</base-button
              >
            </div>
            <div class="col-lg"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Alert } from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import Card from "../../../components/Cards/Card.vue";
import { BCard } from "bootstrap-vue";
import { Modal, ImageUpload } from "../../../../src/components";
import { debounce } from "src/util/debounce";
import Loading from "vue-loading-overlay";

export default {
  name: "VendorRegistration-2",
  components: { Card, BCard, Modal, ImageUpload, Circle8, Loading },

  data() {
    return {
      attempt: 0,
      isLoading: false,
      vehicle_unique: "",
      ic: "",
      validation: [],

      delete: "false",
      vehicle_reg_no: "",
      vehicle_driver_name: "",
      vehicle_driver_ic: "",

      selectedFileName: "",
      allfilename: [],

      cards: [],
      vehicles: [
        {
          id: 0,
          platenumber: "",
          errormsg: "",
        },
      ],
      vehicleslength: 0,
      drivers: [
        {
          id: 0,
          icdriver: "",
          error1msg: "",
        },
      ],
      driverslength: 0,

      vehiclecards: [],

      drivername: [],
      driveric: [],

      vehicle: [],
      driver: [],

      pic: [],

      cardCount: 0,
      cardVehicleCount: 0,
      cardDriverCount: 0,

      transportername: "",
      doe_no: "",
      company_address: "",
      isphone_no: false,
      phone_no: "",
      fax_no: "",
      supportingdoc: [],

      modals: {
        successModal: false,
        failedModal: false,
      },

      //data from user
      companyname: "",
      doeno: "",
      companyaddress: "",
      phoneno: "",
      faxno: "",
      supportdoc: "",

      fullname: "",
      password: "",
      confirmpassword: "",
      phoneno1: "",
      faxno1: "",
      email: "",

      fullname2: "",
      password2: "",
      confirmpassword2: "",
      phoneno2: "",
      faxno2: "",
      email2: "",

      img: null,
      imgdescription: "",
      image: "",
      imagebase64: "",
      images: {
        regular: null,
      },

      addPIC: false,

      documentID: [],
      document_ID: [],

      date_expired: "",

      checkedItems: 0,
      checkedItems1: [],
      checked_Items1: [],

      doedoc: [],
      doe_doc: [],

      uploadload: false,
      upload: false,

      support_doc: "",
      support_doc_list: [],

      vehicleArray: true,
      driverArray: true,
    };
  },
  methods: {
    validatePlateNumber: debounce(function (data, index) {
      console.log(data);

      if (data.platenumber != "") {
        let obj = {
          vehicle_reg_num: data.platenumber,
        };
        console.log("obj : ", obj);
        this.$http
          .post(":10001/api/v1/helper/check-vehicle-number", obj)
          .then((res) => {
            let response = res.message;
            if (!res.error) {
              console.log(response);
              this.vehicles[index].errormsg = res.message;
            } else if (res.error) {
              this.vehicles[index].errormsg = res.message.error_message;
            } else {
              this.vehicles[index].errormsg = res.message;
            }
          });
      }

      // for (var i = 0; i < this.vehicles.length; i++) {
      //   let obj = {
      //     vehicle_reg_num: this.vehicles[i].platenumber,
      //   };
      //   console.log(this.vehicles[i].platenumber)
      //   console.log(this.vehicles[i].errormsg)
      //   this.$http
      //   .post(":10001/api/v1/helper/check-vehicle-number", obj)
      //   .then((res) => {
      //     let response = res.message;

      //     if (!res.error) {

      //       data[i].errormsg = response

      //       this.vehicle_unique = response;
      //       // this.validation[index] = this.vehicle_unique;
      //     } else if (res.error) {
      //       data[i].errormsg = response
      //       this.vehicle_unique = response.error_message;
      //       this.validation[index] = this.vehicle_unique;
      //       console.log("the error here", this.validation[index]);
      //     } else {
      //       this.vehicle_unique = "";
      //       // this.validation[index].push(this.vehicle_unique);
      //       // this.validation[index] = this.vehicle_unique;
      //     }
      //   });
      // }
    }, 500),

    validateICNumber: debounce(function (data, index) {
      console.log(data);

      if (data.platenumber != "") {
        let obj = {
          driver_nric: data.icdriver,
        };
        console.log("obj : ", obj);
        this.$http
          .post(":10001/api/v1/helper/check-driver-nric", obj)
          .then((res) => {
            let response = res.message;
            if (!res.error) {
              console.log(response);
              this.drivers[index].error1msg = res.message;
            } else if (res.error) {
              this.drivers[index].error1msg = res.message.error_message;
            } else {
              this.drivers[index].error1msg = res.message;
            }
          });
      }
    }, 500),

    successModal() {
      this.modals.successModal = true;
    },
    failedModal() {
      this.modals.failedModal = true;
    },
    closeFailedModal() {
      this.modals.failedModal = false;
    },
    cancelRegister() {
      sessionStorage.setItem("vendor-vehicle-reg-no", this.vehiclecards);
      sessionStorage.setItem("vendor-vehicle-driver-name", this.drivername);
      sessionStorage.setItem("vendor-vehicle-driver-ic", this.driveric);

      sessionStorage.setItem("vendor-card-vehicle", this.vehicles.length);
      sessionStorage.setItem("vendor-card-driver", this.drivers.length);

      sessionStorage.setItem("vendor-transporter-name", this.transportername);
      sessionStorage.setItem("vendor-doe-no", this.doe_no);
      sessionStorage.setItem(
        "vendor-transporter-company-address",
        this.company_address
      );
      sessionStorage.setItem("vendor-transporter-phone-no", this.phone_no);
      sessionStorage.setItem("vendor-transporter-fax-no", this.fax_no);

      this.$router.push("/vendor-register-1");
    },
    getLogin() {
      sessionStorage.removeItem("position-id");
      sessionStorage.removeItem("role-id");
      sessionStorage.removeItem("vendor-add-pic");
      sessionStorage.removeItem("vendor-support-doc");
      sessionStorage.removeItem("vendor-support-doc-1");
      sessionStorage.removeItem("vendor-support-doc-2");

      sessionStorage.removeItem("vendor-company-name");
      sessionStorage.removeItem("vendor-company-address");
      sessionStorage.removeItem("vendor-phone-no");
      sessionStorage.removeItem("vendor-fax-no");
      sessionStorage.removeItem("vendor-doe-license");

      sessionStorage.removeItem("vendor-full-name");
      sessionStorage.removeItem("vendor-email");
      sessionStorage.removeItem("vendor-phone-no1");
      sessionStorage.removeItem("vendor-fax-no1");
      sessionStorage.removeItem("vendor-password");
      sessionStorage.removeItem("vendor-confirm-password");

      sessionStorage.removeItem("vendor-full-name2");
      sessionStorage.removeItem("vendor-email2");
      sessionStorage.removeItem("vendor-phone-no2");
      sessionStorage.removeItem("vendor-fax-no2");
      sessionStorage.removeItem("vendor-password2");
      sessionStorage.removeItem("vendor-confirm-password2");

      sessionStorage.removeItem("vendor-facility-index");
      sessionStorage.removeItem("vendor-facility-type-specify");
      sessionStorage.removeItem("vendor-date-expired");
      sessionStorage.removeItem("vendor-waste-index");

      sessionStorage.removeItem("vendor-transporter-name");
      sessionStorage.removeItem("vendor-doe-no");
      sessionStorage.removeItem("vendor-transporter-company-address");
      sessionStorage.removeItem("vendor-transporter-phone-no");
      sessionStorage.removeItem("vendor-transporter-fax-no");

      sessionStorage.removeItem("vendor-vehicle-reg-no");
      sessionStorage.removeItem("vendor-card-vehicle");
      sessionStorage.removeItem("vendor-vehicle-driver-name");
      sessionStorage.removeItem("vendor-vehicle-driver-ic");

      sessionStorage.removeItem("vendor-card-driver");

      this.$router.push("/login");
    },
    addVehicle() {
      this.cardVehicleCount++;

      this.vehicles.push({
        id: this.cardVehicleCount,
        errormsg: "",
        platenumber: "",
      });
    },
    getVehicleTitle(index) {
      return `Vehicle - ${index + 1}`;
    },
    addDriver() {
      this.cardDriverCount++;
      this.drivers.push({ id: this.cardDriverCount });
    },
    getDriverTitle(index) {
      return `Driver - ${index + 1}`;
    },
    handleVehicle(id, index) {
      this.vehicles.splice(index, 1);
    },
    deleteVehicleById(vehicleId, index) {
      const foundIndex = this.vehicles.findIndex(
        (vehicle) => vehicle.id === vehicleId
      );
      if (foundIndex !== -1) {
        this.vehicles.splice(foundIndex, 1);
        this.vehiclecards.splice(foundIndex, 1);
      } else {
      }
    },
    deleteVehicleById2(vehicleId, index) {
      const foundIndex =
        this.vehicles.findIndex((vehicle) => vehicle.id === vehicleId) + 1;

      if (foundIndex !== 0) {
        this.vehicles.splice(foundIndex, 1);
        this.vehiclecards.splice(foundIndex, 1);
      } else {
      }
    },
    handleDriver(id, index) {
      if (this.driverArray) {
        this.deleteDriverById(id, index);
      } else {
        this.deleteDriverById2(id, index);
      }
    },
    deleteDriverById(driverId, index) {
      const foundIndex = this.drivers.findIndex(
        (driver) => driver.id === driverId
      );
      if (foundIndex !== -1) {
        this.drivers.splice(foundIndex, 1);
        this.drivername.splice(foundIndex, 1);
        this.driveric.splice(foundIndex, 1);
      } else {
      }
    },
    deleteDriverById2(driverId, index) {
      const foundIndex =
        this.drivers.findIndex((driver) => driver.id === driverId) + 1;

      if (foundIndex !== 0) {
        this.drivers.splice(foundIndex, 1);
        this.drivername.splice(foundIndex, 1);
        this.driveric.splice(foundIndex, 1);
      } else {
      }
    },
    onFileChange(event) {
      this.upload = true;
      const t = event.target;
      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          this.selectedFileName = t.files[i].name;
          this.allfilename.push(this.selectedFileName);
        }
        sessionStorage.setItem("vendor-support-doc-2", this.allfilename);
      } else {
        this.selectedFileName = "";
      }

      this.document = t.files.length;

      var input;

      if (t.files.length > 0) {
        for (let i = 0; i < t.files.length; i++) {
          input = this.$refs.file.files[i];
          const formData = new FormData();
          formData.append("document", input);
          this.docs = formData;

          this.uploadload = true;
          this.buttondisabled = true;

          this.$http
            .post(
              ":10001/api/v1/upload/transporter_support_document",
              this.docs,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            )
            .then((res) => {
              if (!res.error) {
                let response = res.message;

                console.log("data masuk sini", response);
                this.supportingdoc.push(response.document_id);
                console.log(this.supportingdoc);
              } else {
                console.log("data tak masuk");
              }
            });
          this.uploadload = false;
          this.buttondisabled = false;
        }
      }
    },
    removeFile(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.allfilename.length) {
        this.allfilename.splice(indexToRemove, 1);
        this.documentID.splice(indexToRemove, 1);
      }
      this.$emit("change", null);
    },
    removeFile2(indexToRemove) {
      if (indexToRemove >= 0 && indexToRemove < this.support_doc_list.length) {
        this.documentID.splice(indexToRemove, 1);
        this.support_doc_list.splice(indexToRemove, 1);
      }
      sessionStorage.setItem("vendor-support-doc-2", this.support_doc_list);
      this.$emit("change", null);
    },
    handleDone() {
      this.isLoading = true;

      let pic1 = {
        user_name: this.fullname,
        user_email: this.email,
        user_phone_number: this.phoneno1,
        user_fax_number: this.faxno1,
        password: this.password,
        confirm_password: this.confirmpassword,
      };
      this.pic.push(pic1);

      if (this.addPIC == true) {
        let pic2 = {
          user_name: this.fullname2,
          user_email: this.email2,
          user_phone_number: this.phoneno2,
          user_fax_number: this.faxno2,
          password: this.password2,
          confirm_password: this.confirmpassword2,
        };
        this.pic.push(pic2);
      }

      let vehiclee;
      for (let i = 0; i < this.vehiclecards.length; i++) {
        vehiclee = {
          registration_no: this.vehiclecards[i],
        };
        this.vehicle.push(vehiclee);
      }

      let driverr;
      for (let i = 0; i < this.drivername.length; i++) {
        driverr = {
          driver_name: this.drivername[i],
          driver_nric: this.driveric[i],
        };
        this.driver.push(driverr);
      }

      let obj = {
        pic: this.pic,
        transporter: {
          transporter_name: this.transportername,
          doe_no: this.doe_no,
          transporter_address: this.company_address,
          transporter_phone: this.phone_no,
          transporter_fax: this.fax_no,
          driver: this.driver,
          vehicle: this.vehicle,
          transporter_documents: this.supportingdoc,
        },
        company_name: this.companyname,
        company_address: this.companyaddress,
        company_phone_number: this.phoneno,
        company_fax_number: this.faxno,
        doe_licence: this.doeno,
        doe_expired_at: this.date_expired,
        documents: this.document_ID,
        waste_code_id: this.checked_Items1,
        //if user click no 4, pass the text first and call the id using this post api /api/v1/setting/facilities
        facility_type_id: parseInt(this.checkedItems),
        doe_documents: this.doe_doc,
      };

      console.log("datas", obj);

      this.$http
        .post(":10001/api/v1/register/vendor", obj)
        .then((res) => {
          if (!res.error) {
            swal({
              title: `Success!`,
              text: "Registration success.",
              buttonsStyling: false,
              confirmButtonClass: "btn btn-primary btn-fill",
              type: "success",
            }).then((result) => {
              console.log(result);
              // let response = res.message;
              // console.log(response);
              // console.log("datas", obj);

              // this.modals.successModal = true;

              sessionStorage.removeItem("position-id");
              sessionStorage.removeItem("role-id");
              sessionStorage.removeItem("vendor-add-pic");
              sessionStorage.removeItem("vendor-support-doc");
              sessionStorage.removeItem("vendor-support-doc-1");
              sessionStorage.removeItem("vendor-support-doc-2");

              sessionStorage.removeItem("vendor-company-name");
              sessionStorage.removeItem("vendor-operation-type");
              sessionStorage.removeItem("vendor-company-address");
              sessionStorage.removeItem("vendor-phone-no");
              sessionStorage.removeItem("vendor-fax-no");
              sessionStorage.removeItem("vendor-doe-license");

              sessionStorage.removeItem("vendor-full-name");
              sessionStorage.removeItem("vendor-email");
              sessionStorage.removeItem("vendor-phone-no1");
              sessionStorage.removeItem("vendor-fax-no1");
              sessionStorage.removeItem("vendor-password");
              sessionStorage.removeItem("vendor-confirm-password");

              sessionStorage.removeItem("vendor-full-name2");
              sessionStorage.removeItem("vendor-email2");
              sessionStorage.removeItem("vendor-phone-no2");
              sessionStorage.removeItem("vendor-fax-no2");
              sessionStorage.removeItem("vendor-password2");
              sessionStorage.removeItem("vendor-confirm-password2");

              sessionStorage.removeItem("vendor-ship-name");
              sessionStorage.removeItem("vendor-imo-no");
              sessionStorage.removeItem("vendor-gross-tonnage");
              sessionStorage.removeItem("vendor-dead-weight");
              sessionStorage.removeItem("vendor-owner-name");

              sessionStorage.removeItem("vendor-facility-index");
              sessionStorage.removeItem("vendor-facility-type-specify");
              sessionStorage.removeItem("vendor-date-expired");
              sessionStorage.removeItem("vendor-waste-index");

              sessionStorage.removeItem("vendor-transporter-name");
              sessionStorage.removeItem("vendor-doe-no");
              sessionStorage.removeItem("vendor-transporter-company-address");
              sessionStorage.removeItem("vendor-transporter-phone-no");
              sessionStorage.removeItem("vendor-transporter-fax-no");

              sessionStorage.removeItem("vendor-vehicle-reg-no");
              sessionStorage.removeItem("vendor-card-vehicle");

              sessionStorage.removeItem("vendor-vehicle-driver-name");
              sessionStorage.removeItem("vendor-vehicle-driver-ic");
              sessionStorage.removeItem("vendor-card-driver");

              setTimeout(() => {
                this.$router.push("/login")
              }, 2000)
            });
          } else {
            console.log("ewor");
          }
        })
        .catch((err) => {
          swal({
            title: `Error!`,
            text: "Registration failed.",
            buttonsStyling: false,
            confirmButtonClass: "btn btn-cancel btn-fill",
            type: "error",
          });
        });

      this.isLoading = false;
    },
  },
  watch: {
    phone_no() {
      if (this.phone_no.length <= 7) {
        this.isphone_no = true;
      } else {
        this.isphone_no = false;
      }
    },
    vehicles: {
      handler: function (val, oldVal) {
        console.log(val);
        for (var i = 0; i < val.length; i++) {
          this.validatePlateNumber(val[i], i);
        }
      },
      deep: true,
    },
    vehiclecards: debounce(function (index) {
      this.vehicle_unique = "";
      this.validation.length = this.vehiclecards.length;

      console.log("");

      let obj = {
        vehicle_reg_num: this.vehiclecards[index],
      };

      this.$http
        .post(":10001/api/v1/helper/check-vehicle-number", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.vehicle_unique = response;
          } else if (res.error) {
            this.vehicle_unique = response.error_message;
            this.validation[index] = this.vehicle_unique;
            console.log("the error here", this.validation[index]);
          } else {
            this.vehicle_unique = "";
          }
        })
        .catch((err) => {
          this.vehicle_unique = err.response.data.message;
        });
      this.vehicle_unique = "";
    }, 1000),

    drivers: {
      handler: function (val, oldVal) {
        console.log(val);
        for (var i = 0; i < val.length; i++) {
          this.validateICNumber(val[i], i);
        }
      },
      deep: true,
    },
    driveric: debounce(function (index) {
      this.ic = "";
      this.validation.length = this.driveric.length;

      console.log("");

      let obj = {
        vehicle_reg_num: this.driveric[index],
      };

      this.$http
        .post(":10001/api/v1/helper/check-vehicle-number", obj)
        .then((res) => {
          let response = res.message;
          if (!res.error) {
            this.vehicle_unique = response;
          } else if (res.error) {
            this.vehicle_unique = response.error_message;
            this.validation[index] = this.vehicle_unique;
            console.log("the error here", this.validation[index]);
          } else {
            this.vehicle_unique = "";
          }
        })
        .catch((err) => {
          this.vehicle_unique = err.response.data.message;
        });
      this.vehicle_unique = "";
    }, 1000),

    // driveric: debounce(function (index) {
    //   this.ic = "";

    //   if (this.driveric[index] != "") {
    //     let obj = {
    //       driver_nric: this.driveric[index],
    //     };

    //     this.$http
    //       .post(":10001/api/v1/helper/check-driver-nric", obj)
    //       .then((res) => {
    //         let response = res.message;

    //         if (!res.error) {
    //           this.ic = response;
    //         } else if (res.error) {
    //           this.ic = response.error_message;
    //         } else {
    //           this.ic = "";
    //         }
    //       });
    //     this.ic = "";
    //   }
    // }, 500),
  },

  created() {},
  computed: {
    checkNo: {
      get() {
        return this.fax_no.startsWith("0") || this.fax_no.startsWith("+")
          ? this.phone_no
          : this.fax_no;
      },
      set(value) {
        if (value.startsWith("0")) {
          this.phone_no = value;
          this.fax_no = "";
        } else {
          this.fax_no = value;
          this.phone_no = "";
        }
      },
    },
  },
  mounted() {
    this.companyname = sessionStorage.getItem("vendor-company-name");
    this.companyaddress = sessionStorage.getItem("vendor-company-address");
    this.phoneno = sessionStorage.getItem("vendor-phone-no");
    this.faxno = sessionStorage.getItem("vendor-fax-no");
    this.doeno = sessionStorage.getItem("vendor-doe-license");

    this.fullname = sessionStorage.getItem("vendor-full-name");
    this.email = sessionStorage.getItem("vendor-email");
    this.phoneno1 = sessionStorage.getItem("vendor-phone-no1");
    this.faxno1 = sessionStorage.getItem("vendor-fax-no1");
    this.password = sessionStorage.getItem("vendor-password");
    this.confirmpassword = sessionStorage.getItem("vendor-confirm-password");

    this.fullname2 = sessionStorage.getItem("vendor-full-name2");
    this.email2 = sessionStorage.getItem("vendor-email2");
    this.phoneno2 = sessionStorage.getItem("vendor-phone-no2");
    this.faxno2 = sessionStorage.getItem("vendor-fax-no2");
    this.password2 = sessionStorage.getItem("vendor-password2");
    this.confirmpassword2 = sessionStorage.getItem("vendor-confirm-password2");

    this.addPIC = sessionStorage.getItem("vendor-add-pic");

    this.checkedItems = sessionStorage.getItem("vendor-checked-item");
    this.doedoc = sessionStorage.getItem("vendor-doe-document");
    this.date_expired = sessionStorage.getItem("vendor-date-expired");

    this.transportername =
      sessionStorage.getItem("vendor-transporter-name") !== null &&
      sessionStorage.getItem("vendor-transporter-name") !== "null"
        ? sessionStorage.getItem("vendor-transporter-name")
        : "";

    this.doe_no =
      sessionStorage.getItem("vendor-doe-no") !== null &&
      sessionStorage.getItem("vendor-doe-no") !== "null"
        ? sessionStorage.getItem("vendor-doe-no")
        : "";

    this.doe_no =
      sessionStorage.getItem("vendor-doe-no") !== null &&
      sessionStorage.getItem("vendor-doe-no") !== "null"
        ? sessionStorage.getItem("vendor-doe-no")
        : "";

    this.company_address =
      sessionStorage.getItem("vendor-transporter-company-address") !== null &&
      sessionStorage.getItem("vendor-transporter-company-address") !== "null"
        ? sessionStorage.getItem("vendor-transporter-company-address")
        : "";

    this.phone_no =
      sessionStorage.getItem("vendor-transporter-phone-no") !== null &&
      sessionStorage.getItem("vendor-transporter-phone-no") !== "null"
        ? sessionStorage.getItem("vendor-transporter-phone-no")
        : "";

    this.fax_no =
      sessionStorage.getItem("vendor-transporter-fax-no") !== null &&
      sessionStorage.getItem("vendor-transporter-fax-no") !== "null"
        ? sessionStorage.getItem("vendor-transporter-fax-no")
        : "";

    this.support_doc = sessionStorage.getItem("vendor-support-doc-2");

    if (this.support_doc) {
      this.support_doc_list = this.support_doc.trim().split(",").map(String);
    } else {
      this.support_doc_list = [];
    }

    this.vehicle_reg_no =
      sessionStorage.getItem("vendor-vehicle-reg-no") !== null &&
      sessionStorage.getItem("vendor-vehicle-reg-no") !== "null"
        ? sessionStorage.getItem("vendor-vehicle-reg-no")
        : "";
    this.vehicle_reg_no = sessionStorage.getItem("vendor-vehicle-reg-no");
    this.vehiclecards = this.vehicle_reg_no.split(",").map(String);

    this.vehicleslength = sessionStorage.getItem("vendor-card-vehicle");
    this.vehicleslength = parseInt(this.vehicleslength);
    this.vehicles.length = this.vehicleslength;
    this.vehicleArray = false;

    this.vehicles = new Array(this.vehicleslength).fill({
      id: null,
    });

    this.vehicle_driver_name =
      sessionStorage.getItem("vendor-vehicle-driver-name") !== null &&
      sessionStorage.getItem("vendor-vehicle-driver-name") !== "null"
        ? sessionStorage.getItem("vendor-vehicle-driver-name")
        : "";
    this.vehicle_driver_name = sessionStorage.getItem(
      "vendor-vehicle-driver-name"
    );
    this.drivername = this.vehicle_driver_name.split(",").map(String);

    this.vehicle_driver_ic =
      sessionStorage.getItem("vendor-vehicle-driver-ic") !== null &&
      sessionStorage.getItem("vendor-vehicle-driver-ic") !== "null"
        ? sessionStorage.getItem("vendor-vehicle-driver-ic")
        : "";
    this.vehicle_driver_ic = sessionStorage.getItem("vendor-vehicle-driver-ic");
    this.driveric = this.vehicle_driver_ic.split(",").map(String);

    this.driverslength = sessionStorage.getItem("vendor-card-driver");
    this.driverslength = parseInt(this.driverslength);
    this.drivers.length = this.driverslength;
    this.driverArray = false;

    this.drivers = new Array(this.driverslength).fill({
      id: null /* other properties */,
    });
  },
};
</script>
<style scoped>
.navbar-nav .nav-item p {
  line-height: inherit;
  margin-left: 5px;
}

.scrollable {
  height: 460px;
  overflow-y: scroll;
  padding: 0px 0px 0px 30px;
  color: #A5A5A5;
}

.card .card-header {
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
  font-size: 18px;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
</style>
